import React from 'react';
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    Icon,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Paper,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import GoogleMapReact from 'google-map-react';
import moment from 'moment-timezone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import { DatePicker, DateTimePicker } from 'material-ui-pickers';
import WarningIcon from '@material-ui/icons/Error';
import AddIcon from '@material-ui/icons/Add';
import classNames from 'classnames';
import GaugeChart from 'react-gauge-chart';
import { isEmpty } from 'lodash';
import PhoneIcon from '@material-ui/icons/Phone';
import HybridTextField from '../hybridTextField';
import titalise from '../../utilities/titalise';
import {
    titles,
    counties,
    countries,
    intDialCodes,
} from '../../utilities/menuOptions';
import Tile from '../../containers/tile';
import ContactCreditScore from './contactCreditScore';
import titaliseWithHyphen from '../../utilities/titaliseWithHyphen';
import ukFlag from '../../ukFlag.png';
import roiFlag from '../../roiFlag.png';
import ItemHistory from './itemHistory';

const AMPLIFY5 = 1002;

const styles = (theme) => ({
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    tableHead: {
        fontWeight: 'bold',
        fontSize: 14,
    },
    paper: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowX: 'auto',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    tileBottomDivider: {
        marginTop: theme.spacing.unit * 3,
        // marginBottom: theme.spacing.unit * 2,
    },
    dialogDivider: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        marginLeft: -24,
        marginRight: -24,
    },
    bottomBarContainer: {
        width: '100%',
        textAlign: 'right',
    },
    textButton: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: 0,
    },
    dialogActions: {
        marginRight: theme.spacing.unit * 2.5,
    },
    nameField: {
        width: 350,
    },
    addressField: {
        width: 250,
    },
    postcodeField: {
        width: 120,
    },
    countryField: {
        width: 200,
        marginLeft: theme.spacing.unit * 3,
    },
    emailField: {
        width: 350,
    },
    rightOfFieldButton: {
        marginTop: 10,
        marginLeft: theme.spacing.unit * 3,
        color: 'rgba(0, 121, 255, 0.87)',
    },
    dialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    contactVulnerabilityDialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 3,
        minWidth: 550,
    },
    dialogButton: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 1,
    },
    dialogContent: {
        paddingBottom: 0,
        minWidth: 400,
    },
    formHelperText: {
        color: '#f44336',
    },
    contactLocationIcon: {
        color: 'red',
        fontSize: 30,
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
    },
    branchLocationIcon: {
        color: 'blue',
        fontSize: 30,
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
    },
    progressContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        width: 60,
    },
    progress: {
        opacity: '.5',
    },
    inputLabel: {
        backgroundColor: '#fff',
        paddingLeft: 8,
        marginLeft: -5,
        paddingRight: 8,
    },
    menuFormControl: {
        marginBottom: theme.spacing.unit * 1,
        marginTop: theme.spacing.unit * 2,
    },
    // agents: {
    //     marginRight: theme.spacing.unit * 3,
    // },
    // 'agents:not(:first-child)': {
    //     marginLeft: 0,
    //     backgroundColor: 'red',
    // },
    debtCompanyContainer: {
        height: '100%',
    },
    debtCompany: {
        boxShadow: '0 0 0 3px #f44336, 0 0 0 2px #f44336 inset',
        border: '2px solid transparent',
        borderRadius: 4,
        display: 'inline-block',
        padding: '5px 2px',
        color: '#f44336',
        fontSize: 24,
        textTransform: 'uppercase',
        textAlign: 'center',
        // opacity: 0.6,
        fontWeight: 900,
        position: 'absolute',
        top: '60%',
        left: '50%',
        transform: 'rotate(-5deg) translate(-50%,-50%)',
        minWidth: '80%',
        background: '#ffffff7d',
    },
    debtCompanyName: {
        fontSize: 80,
    },
    debtNoContact: {
        fontSize: 40,
    },
    textFieldLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 11,
        fontWeight: 400,
        marginBottom: 4,
    },
    creditScoreContainer: {
        marginBottom: 16,
    },
    dialogCreditScoreContainer: {
        marginBottom: 8,
        marginTop: 8,
        minHeight: 69,
    },
    dialogTitle: {
        marginBottom: 16,
    },
    dialogSubTitle: {
        fontSize: 18,
        fontWeight: 500,
        marginBottom: 16,
    },
    cardRadio: {
        // paddingTop: '0px',
    },
    radio: {
        '&:first-of-type': {
            marginTop: 8,
        },
    },
    radioButtonsContainer: {
        marginLeft: theme.spacing.unit * 2,
    },
    circle: {
        borderRadius: '50%',
        width: 20,
        height: 20,
        paddingTop: 1,
        background: '#fff',
        border: '2px solid #f44336',
        color: '#f44336',
        textAlign: 'center',
        fontWeight: 600,
        font: '14px Arial, sans-serif',
    },
    historyPaper: {
        backgroundColor: theme.palette.background.default,
        border: '1px solid #e0e0e0',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing.unit * 2,
        overflowX: 'auto',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 1}px`,
        width: '100%',
    },
    blackTableIcons: {
        color: '#000000',
        fontSize: 22,
        opacity: 0.6,
    },
    bumpTop2U: {
        marginTop: theme.spacing.unit * 2,
    },
    contentCopyIcon: {
        cursor: 'pointer',
        color: '#0074cc',
        '&:hover': {
            color: '#0a95ff',
        },
        '&:active': {
            color: '#aaa',
        },
    },
    rightButton: {
        textAlign: 'right',
    },
    phoneNumber: {
        marginTop: -12,
    },
    alertPhoneNumber: {
        paddingBottom: 16,
        color: '#f00',
        fontWeight: 500,
    },
    emptyPhoneNumber: {
        minHeight: 35,
    },
    flag: {
        width: 100,
        marginBottom: 16,
    },
    phoneNumberContainer: {
        display: 'flex',
        alignItems: 'left',
        gap: 8,
    },
    phoneNumberIntDialCode: {
        marginTop: 13,
        marginRight: 8,
    },
    intDialCodeContainer: {
        display: 'flex',
        alignItems: 'left',
        minWidth: 110,
    },
    intDialCode: {
        minWidth: 90,
        marginRight: 24,
    },
    intDialCodeFlag: {
        width: 20,
        marginRight: 8,
    },
});

class ItemDeliveryNote extends React.Component {
    state = {
        // disableInvalidAddressSwitch: false,
        // disableInvalidAddressSubmitButton: false,
        // disableInvalidMobileTelephoneNumberSwitch: false,
        // disableInvalidMobileTelephoneNumberSubmitButton: false,
        // disableForbidAgreementSwitch: false,
        // disableForbidAgreementSubmitButton: false,
        // disableForbidSaleSwitch: false,
        // disableForbidSaleSubmitButton: false,
        // disableEditContactAddressSaveButton: false,
        // disableEditContactDetailsSaveButton: false,
        // disableEditContactSecurityQuestionsSaveButton: false,
        // disableEditTransUnionCreditScoreSaveButton: false,
        // disableExpireContactVulnerabilityButton: false,
        // disableContactVulnerabilityAddButton: false,
        // disableSendSMSButton: false,
        // disableSyncDetailsButton: false,
        // disableSendEmailButton: false,
        // contactVulnerabilityAddData: {},
        // editTransUnionCreditScoreData: {},
        // showInvalidAddressDialog: false,
        // showInvalidMobileTelephoneNumberDialog: false,
        // showForbidAgreementDialog: false,
        // showForbidSaleDialog: false,
        // showContactAddressEditDialog: false,
        // showTransUnionCreditScoreEditDialog: false,
        // showTransUnionCreditScoreEditDialog: false,
        // showContactDetailsEditDialog: false,
        // showCreditScoreDetailsDialog: false,
        // showCreditReportDialog: false,
        // showContactVulnerabilityDialog: false,
        // showContactVulnerabilityAddDialog: false,
        // showContactSecurityAnswersDialog: false,
        // showContactSecurityQuestionsEditDialog: false,
        // showFindAgentsDialog: false,
        // showSendSMSDialog: false,
        // showSyncDetailsDialog: false,
        // showSendEmailDialog: false,
        // smsForm: {
        //     message: '',
        // },
        // sendDeclineEmailData: {
        //     emailContentName: 'declineAgreementEmailContent',
        // },
        // emailForm: {
        //     content: '',
        //     subject: '',
        // },
        // contactDetailsForm: {
        //     title: '',
        //     firstname: '',
        //     surname: '',
        //     homeTelephoneNumber: '',
        //     mobileTelephoneNumber: '',
        //     emailAddress: '',
        //     gdpr: '',
        //     dateOfBirth: '',
        //     mobileTelephoneNumberIntDialCode: '',
        //     homeTelephoneNumberNote: '',
        //     mobileTelephoneNumberNote: '',
        // },
        // contactAddressForm: {
        //     newAddress: 'false',
        //     address1: '',
        //     address2: '',
        //     townCity: '',
        //     county: '',
        //     postcode: '',
        //     country: '',
        // },
        // contactSecurityQuestionsForm: {
        //     favouritePet: '',
        //     memorableWord: '',
        //     mothersMaidenName: '',
        // },
        // invalidAddressData: {
        //     invalidAddressReason: '',
        // },
        // invalidMobileTelephoneNumberData: {
        //     invalidMobileTelephoneNumberReason: '',
        // },
        // forbidAgreementData: {
        //     forbidAgreementReason: '',
        // },
        // forbidSaleData: {
        //     forbidSaleReason: '',
        // },
    };

    componentDidMount() {
        // this.setupFormData();
    }

    // componentDidUpdate(prevProps) {
    //     if (
    //         (this.props.contact !== prevProps.contact)
    //         || (this.props.users !== prevProps.users)
    //         || (this.props.user !== prevProps.user)
    //     ) {
    //         this.setupFormData();
    //     }
    // }

    // setupFormData() {
    //     if (this.props.contact) {
    //         this.setState((state) => ({
    //             contactDetailsForm: {
    //                 ...state.contactDetailsForm,
    //                 title: this.props.contact.title,
    //                 firstname: this.props.contact.firstname,
    //                 surname: this.props.contact.surname,
    //                 homeTelephoneNumber: this.props.contact.homeTelephoneNumber,
    //                 mobileTelephoneNumber: this.props.contact.mobileTelephoneNumber,
    //                 emailAddress: this.props.contact.emailAddress,
    //                 gdpr: this.props.contact.gdpr,
    //                 dateOfBirth: this.props.contact.dateOfBirth,
    //                 mobileTelephoneNumberIntDialCode: this.props.contact.mobileTelephoneNumberIntDialCode,
    //                 homeTelephoneNumberIntDialCode: this.props.contact.homeTelephoneNumberIntDialCode,
    //                 homeTelephoneNumberNote: this.props.contact.homeTelephoneNumberNote,
    //                 mobileTelephoneNumberNote: this.props.contact.mobileTelephoneNumberNote,
    //             },
    //             contactAddressForm: {
    //                 ...state.contactAddressForm,
    //                 newAddress: 'false',
    //                 address1: this.props.contact.address.address1,
    //                 address2: this.props.contact.address.address2,
    //                 townCity: this.props.contact.address.townCity,
    //                 county: this.props.contact.address.county,
    //                 postcode: this.props.contact.address.postcode,
    //                 country: this.props.contact.address.country,
    //             },
    //             emailForm: {
    //                 ...state.emailForm,
    //                 content: `Hello ${this.props.contact.firstname},

    //     `,
    //                 subject: 'Pay Weekly',
    //             },
    //             editTransUnionCreditScoreData: {
    //                 ...state.editTransUnionCreditScoreData,
    //                 // transUnionCreditScoreCreatedByContactCode: this.props.user.contactCode,
    //                 // transUnionCreditScore: this.props.contact.transUnionCreditScore,
    //                 // transUnionCreditScoreReference: this.props.contact.transUnionCreditScoreReference,
    //                 score: '',
    //                 reference: '',
    //             },
    //         }));
    //     }
    // }

    // handleContactSecurityAnswersClick = () => {
    //     this.setState({
    //         showContactSecurityAnswersDialog: true,
    //     });
    //     this.props.fetchContactSecurityAnswers();
    // };

    // handleFindAgentsClick = () => {
    //     this.setState({
    //         showFindAgentsDialog: true,
    //     });
    //     this.props.fetchContactContactAgents();
    // };

    // handleContactSecurityAnswersCloseDialogClick = () => {
    //     this.setState({
    //         showContactSecurityAnswersDialog: false,
    //     });
    // };

    // //

    // handleContactSecurityQuestionsEditClick = async () => {
    //     this.setState({
    //         showContactSecurityQuestionsEditDialog: true,
    //     });

    //     await this.props.fetchContactSecurityAnswers();

    //     this.setState({
    //         contactSecurityQuestionsForm: {
    //             ...this.props.contact.securityAnswers,
    //         },
    //     });
    // };

    // handleContactSecurityQuestionsCloseDialogClick = () => {
    //     this.setState({
    //         showContactSecurityQuestionsEditDialog: false,
    //     });
    // };

    // handleFindAgentsCloseDialogClick = () => {
    //     this.setState({
    //         showFindAgentsDialog: false,
    //     });
    // };

    // //

    // handleContactDetailsEditClick = () => {
    //     this.setState({
    //         showContactDetailsEditDialog: true,
    //     });
    // };

    // handleTransUnionCreditScoreEditClick = () => {
    //     this.setupFormData();
    //     this.setState({
    //         showTransUnionCreditScoreEditDialog: true,
    //     });
    // };

    // handleCreditScoreDetailsClick = () => {
    //     this.setState({
    //         showCreditScoreDetailsDialog: true,
    //     });
    // };

    // handleCreditReportClick = () => {
    //     this.setState({
    //         showCreditReportDialog: true,
    //     });
    //     this.props.fetchContactCreditReport();
    // };

    // handleContactVulnerabilityClick = () => {
    //     this.setState({
    //         showContactVulnerabilityDialog: true,
    //     });
    //     this.props.fetchContactVulnerabilities();
    // };

    // handleContactVulnerabilityAddClick = () => {
    //     this.setState({
    //         contactVulnerabilityAddData: {},
    //         showContactVulnerabilityAddDialog: true,
    //     });
    // };

    // handleContactAddressEditClick = () => {
    //     this.setState({
    //         showContactAddressEditDialog: true,
    //     });
    // };

    // handleContactDetailsCloseDialogClick = () => {
    //     this.setState({
    //         showContactDetailsEditDialog: false,
    //     });
    // };

    // handleTransUnionCreditScoreCloseDialogClick = () => {
    //     this.setState({
    //         showTransUnionCreditScoreEditDialog: false,
    //     });
    // };

    // handleCreditScoreDetailsCloseDialogClick = () => {
    //     this.setState({
    //         showCreditScoreDetailsDialog: false,
    //     });
    // };

    // handleCreditReportCloseDialogClick = () => {
    //     this.setState({
    //         showCreditReportDialog: false,
    //     });
    // };

    // handleContactVulnerabilityCloseDialogClick = () => {
    //     this.setState({
    //         showContactVulnerabilityDialog: false,
    //     });
    // };

    // handleContactVulnerabilityAddCloseDialogClick = () => {
    //     this.setState({
    //         showContactVulnerabilityAddDialog: false,
    //     });
    // };

    // handleContactAddressCloseDialogClick = () => {
    //     this.setState({
    //         showContactAddressEditDialog: false,
    //     });
    // };

    // handleSendSMSClick = () => {
    //     this.setState({
    //         showSendSMSDialog: true,
    //     });
    // };

    // handleSyncDetailsClick = () => {
    //     this.setState({
    //         showSyncDetailsDialog: true,
    //     });
    // };

    // handleSendEmailClick = () => {
    //     this.setState({
    //         showSendEmailDialog: true,
    //     });
    // };

    // handleSendDeclineAgreementEmailClick = () => {
    //     this.setState({
    //         showSendDeclineAgreementEmailDialog: true,
    //     });
    // };

    // // handleSalesStatusClick = () => {
    // //     this.setState((state) => ({
    // //         salesStatusData: {
    // //             ...state.salesStatusData,
    // //             salePermission: this.props.contact.salePermission === 'PERMIT' ? 'FORBID' : 'PERMIT',
    // //         },
    // //         showSalesStatusDialog: true,
    // //     }));
    // // };

    // handleSendSMSCloseDialogClick = () => {
    //     this.setState({
    //         showSendSMSDialog: false,
    //     });
    // };

    // handleSyncDetailsCloseDialogClick = () => {
    //     this.setState({
    //         showSyncDetailsDialog: false,
    //     });
    // };

    // handleSendEmailCloseDialogClick = () => {
    //     this.setState({
    //         showSendEmailDialog: false,
    //     });
    // };

    // handleSendDeclineAgreementEmailCloseDialogClick = () => {
    //     this.setState({
    //         showSendDeclineAgreementEmailDialog: false,
    //     });
    // };

    // handleInvalidAddressCloseDialogClick = () => {
    //     this.setState({
    //         showInvalidAddressDialog: false,
    //     });
    // };

    // handleInvalidMobileTelephoneNumberCloseDialogClick = () => {
    //     this.setState({
    //         showInvalidMobileTelephoneNumberDialog: false,
    //     });
    // };

    // handleForbidAgreementCloseDialogClick = () => {
    //     this.setState({
    //         showForbidAgreementDialog: false,
    //     });
    // };

    // handleForbidSaleCloseDialogClick = () => {
    //     this.setState({
    //         showForbidSaleDialog: false,
    //     });
    // };

    // handleEditContactDetailsCheckBoxClick = (name) => (event) => {
    //     const newValue = this.state.contactDetailsForm[name] !== true;
    //     this.setState((state) => ({
    //         contactDetailsForm: {
    //             ...state.contactDetailsForm,
    //             [name]: newValue,
    //         },
    //     }));
    // };

    // handleContactDateOfBirthChange = (chosenDate) => {
    //     this.setState((state) => ({
    //         contactDetailsForm: {
    //             ...state.contactDetailsForm,
    //             dateOfBirth: moment(chosenDate).format('YYYY-MM-DD'),
    //         },
    //     }));
    // };

    // updateEditSecurityQuestionsData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         contactSecurityQuestionsForm: {
    //             ...state.contactSecurityQuestionsForm,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateSendDeclineEmailData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         sendDeclineEmailData: {
    //             ...state.sendDeclineEmailData,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateInvalidAddressData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         invalidAddressData: {
    //             ...state.invalidAddressData,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateInvalidMobileTelephoneNumberData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         invalidMobileTelephoneNumberData: {
    //             ...state.invalidMobileTelephoneNumberData,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateForbidAgreementData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         forbidAgreementData: {
    //             ...state.forbidAgreementData,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateForbidSaleData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         forbidSaleData: {
    //             ...state.forbidSaleData,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateEditContactDetailsData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     case 'emailAddress':
    //         formattedValue = value.replace(/[^a-zA-Z0-9_\-/-@.]/g, '').toLowerCase();
    //         break;
    //     case 'homeTelephoneNumberNote':
    //     case 'mobileTelephoneNumberNote':
    //         formattedValue = value;
    //         break;
    //     default:
    //         formattedValue = titaliseWithHyphen(value);
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         contactDetailsForm: {
    //             ...state.contactDetailsForm,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateContactVulnerabilityAddData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     let additionalValues;
    //     switch (name) {
    //     case 'typeCode':
    //         formattedValue = value;
    //         additionalValues = {
    //             typeDescription: this.props.vulnerabilityTypes.find((vulnerabilityType) => vulnerabilityType.code === value).description,
    //         };
    //         break;
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         contactVulnerabilityAddData: {
    //             ...state.contactVulnerabilityAddData,
    //             [name]: formattedValue,
    //             ...additionalValues,
    //         },
    //     }));
    // };

    // updateEditTransUnionCreditScoreData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     case 'score':
    //         formattedValue = value.replace(/[^0-9$.]/g, '');
    //         break;
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         editTransUnionCreditScoreData: {
    //             ...state.editTransUnionCreditScoreData,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateEditContactAddressData = (event) => {
    //     const { name, value } = event.target;
    //     let formattedValue;
    //     let contactAddressFormValues = { ...this.state.contactAddressForm };
    //     switch (name) {
    //     case 'postcode':
    //         formattedValue = value.toUpperCase();
    //         break;
    //     case 'county':
    //     case 'country':
    //     case 'newAddress':
    //         formattedValue = value;
    //         break;
    //     default:
    //         formattedValue = titalise(value);
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     if (name === 'newAddress' && value === 'true') {
    //         Object.keys(contactAddressFormValues).forEach((k) => contactAddressFormValues[k] = '');
    //     } else if (name === 'newAddress' && value === 'false') {
    //         contactAddressFormValues = {
    //             address1: this.props.contact.address.address1,
    //             address2: this.props.contact.address.address2,
    //             townCity: this.props.contact.address.townCity,
    //             county: this.props.contact.address.county,
    //             postcode: this.props.contact.address.postcode,
    //             country: this.props.contact.address.country,
    //         };
    //     }

    //     this.setState({
    //         contactAddressForm: {
    //             ...contactAddressFormValues,
    //             [name]: formattedValue,
    //         },
    //     });
    // };

    // handleSaveContactSecurityQuestions = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableEditContactSecurityQuestionsSaveButton: true,
    //     });
    //     this.props.saveContactSecurityQuestions(this.state.contactSecurityQuestionsForm).then(() => {
    //         this.setState({
    //             showContactSecurityQuestionsEditDialog: false,
    //             disableEditContactSecurityQuestionsSaveButton: false,
    //         });
    //         this.props.enqueueSnackbar('Contact Security Questions saved', { variant: 'success' });
    //     }).catch(() => {
    //         console.log(this.props.errors);
    //         this.props.enqueueSnackbar('Contact Security Questions save failed', { variant: 'error' });
    //         this.setState({
    //             disableEditContactSecurityQuestionsSaveButton: false,
    //         });
    //     });
    // };

    // handleExpireContactVulnerability = (code, event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableExpireContactVulnerabilityButton: true,
    //     });
    //     this.props.expireContactVulnerability(code).then(() => {
    //         this.setState({
    //             disableExpireContactVulnerabilityButton: false,
    //             showContactVulnerabilityDialog: false,
    //         });
    //         this.props.enqueueSnackbar('Contact Vulnerability Expired', { variant: 'success' });
    //     }).catch(() => {
    //         console.log(this.props.errors);
    //         this.props.enqueueSnackbar('Expire Contact Vulnerability failed', { variant: 'error' });
    //         this.setState({
    //             disableExpireContactVulnerabilityButton: false,
    //         });
    //     });
    // };

    // handleSaveContactDetails = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableEditContactDetailsSaveButton: true,
    //     });
    //     this.props.saveContactDetails(this.state.contactDetailsForm).then(() => {
    //         this.setState({
    //             showContactDetailsEditDialog: false,
    //             disableEditContactDetailsSaveButton: false,
    //         });
    //         this.props.enqueueSnackbar('Contact details saved', { variant: 'success' });
    //     }).catch(() => {
    //         console.log(this.props.errors);
    //         this.props.enqueueSnackbar('Contact details save failed', { variant: 'error' });
    //         this.setState({
    //             disableEditContactDetailsSaveButton: false,
    //         });
    //     });
    // };

    // handleInsertCreditReport = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableEditTransUnionCreditScoreSaveButton: true,
    //     });
    //     const payload = {
    //         ...this.state.editTransUnionCreditScoreData,
    //         type: 'MANUAL',
    //     };
    //     this.props.insertCreditReport(payload).then(() => {
    //         this.setState({
    //             showTransUnionCreditScoreEditDialog: false,
    //             disableEditTransUnionCreditScoreSaveButton: false,
    //         });
    //         this.props.enqueueSnackbar('Credit Report saved', { variant: 'success' });
    //     }).catch(() => {
    //         console.log(this.props.errors);
    //         this.props.enqueueSnackbar('Credit Report save failed', { variant: 'error' });
    //         this.setState({
    //             disableEditTransUnionCreditScoreSaveButton: false,
    //         });
    //     });
    // };

    // handleSaveContactAddress = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableEditContactAddressSaveButton: true,
    //     });
    //     const payload = {
    //         ...this.state.contactAddressForm,
    //         newAddress: this.state.contactAddressForm.newAddress === 'true',
    //     };
    //     this.props.saveContactAddress(payload).then(() => {
    //         this.setState({
    //             showContactAddressEditDialog: false,
    //             disableEditContactAddressSaveButton: false,
    //         });
    //         this.props.enqueueSnackbar('Contact Address saved', { variant: 'success' });
    //     }).catch(() => {
    //         console.log(this.props.errors);
    //         this.props.enqueueSnackbar('Contact Address save failed', { variant: 'error' });
    //         this.setState({
    //             disableEditContactAddressSaveButton: false,
    //         });
    //     });
    // };

    // updateSendSMSData = (event) => {
    //     const { name, value } = event.target;
    //     const wrappedMessage = `PAY WEEKLY: ${value}. Do not reply.`;
    //     this.setState({
    //         smsForm: {
    //             ...this.state.smsForm,
    //             content: wrappedMessage,
    //         },
    //     });
    // };

    // updateSendEmailData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     case 'subject':
    //         formattedValue = titaliseWithHyphen(value);
    //         break;
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         emailForm: {
    //             ...state.emailForm,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // updateSalesStatusData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     switch (name) {
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         salesStatusData: {
    //             ...state.salesStatusData,
    //             [name]: formattedValue,
    //         },
    //     }));
    // };

    // handleSendSMS = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableSendSMSButton: true,
    //     });
    //     this.props.sendSMS(this.state.smsForm).then(() => {
    //         this.setState({
    //             showSendSMSDialog: false,
    //             disableSendSMSButton: false,
    //         });
    //         this.props.enqueueSnackbar('SMS message sent', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('SMS message failed', { variant: 'error' });
    //         this.setState({
    //             disableSendSMSButton: false,
    //         });
    //     });
    // };

    // handleSyncDetails = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableSyncDetailsButton: true,
    //     });
    //     this.props.syncDetails(this.state.smsForm).then(() => {
    //         this.setState({
    //             showSyncDetailsDialog: false,
    //             disableSyncDetailsButton: false,
    //         });
    //         this.props.enqueueSnackbar('Contact Details Synchronised', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Synchronise Contact Details Failed', { variant: 'error' });
    //         this.setState({
    //             disableSyncDetailsButton: false,
    //         });
    //     });
    // };

    // handleSendSMSAgentDetails = (agent) => {
    //     console.log('>>> agent:', agent);
    //     this.setState({
    //         disableSendSMSAgentDetailsButton: true,
    //     });
    //     const payload = {
    //         content: `Hello ${this.props.contact.firstname}, Your local Pay Weekly sales agent is ${agent.firstname} ${agent.surname} - ${agent.mobileTelephoneNumber}. Do not reply.`,
    //     };
    //     this.props.sendSMSAgentDetails(payload).then(() => {
    //         this.setState({
    //             showFindAgentsDialog: false,
    //             disableSendSMSAgentDetailsButton: false,
    //         });
    //         this.props.enqueueSnackbar('SMS agent details message sent', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('SMS agent details message failed', { variant: 'error' });
    //         this.setState({
    //             disableSendSMSAgentDetailsButton: false,
    //         });
    //     });
    // };

    // handleSendEmail = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableSendEmailButton: true,
    //     });
    //     this.props.sendEmail(this.state.emailForm).then(() => {
    //         this.setState({
    //             showSendEmailDialog: false,
    //             disableSendEmailButton: false,
    //         });
    //         this.props.enqueueSnackbar('Email message sent', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Email message failed', { variant: 'error' });
    //         this.setState({
    //             disableSendEmailButton: false,
    //         });
    //     });
    // };

    // handleSendDeclineAgreementEmail = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableSendDeclineAgreementEmailButton: true,
    //     });
    //     this.props.sendDeclineAgreementEmail(this.state.sendDeclineEmailData).then(() => {
    //         this.setState({
    //             showSendDeclineAgreementEmailDialog: false,
    //             disableSendDeclineAgreementEmailButton: false,
    //         });
    //         this.props.enqueueSnackbar('Decline Agreement Email message sent', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Send Decline Agreement Email message failed', { variant: 'error' });
    //         this.setState({
    //             disableSendDeclineAgreementEmailButton: false,
    //         });
    //     });
    // };

    // handleAddContactVulnerability = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableContactVulnerabilityAddButton: true,
    //     });
    //     this.props.addContactVulnerability(this.state.contactVulnerabilityAddData).then(() => {
    //         this.setState({
    //             showContactVulnerabilityAddDialog: false,
    //             disableContactVulnerabilityAddButton: false,
    //         });
    //         this.props.enqueueSnackbar('Contact Vulnerability Added', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Add Contact Vulnerability Failed', { variant: 'error' });
    //         this.setState({
    //             disableContactVulnerabilityAddButton: false,
    //         });
    //     });
    // };

    // handleSalesStatusSubmit = (event) => {
    //     event.preventDefault();
    //     this.setState({
    //         disableSalesStatusSubmitButton: true,
    //     });
    //     this.props.salesSatusSubmit(this.state.salesStatusData).then(() => {
    //         this.setState({
    //             showSalesStatusDialog: false,
    //             disableSalesStatusSubmitButton: false,
    //         });
    //         this.props.enqueueSnackbar('Changed Sales Status', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Change Sales Status Failed', { variant: 'error' });
    //         this.setState({
    //             disableSalesStatusSubmitButton: false,
    //         });
    //     });
    // };

    // handleRecordDialClick = (phoneType) => (event) => {
    //     console.log('>>> DialAttempt');
    //     // event.preventDefault();
    //     // this.setState({
    //     //     disableSalesStatusSubmitButton: true,
    //     // });
    //     this.props.recordDial(this.props.contact.code, phoneType).then(() => {
    //         // this.setState({
    //         //     showSalesStatusDialog: false,
    //         //     disableSalesStatusSubmitButton: false,
    //         // });
    //         this.props.enqueueSnackbar(`Dial ${titalise(phoneType)} Telephone Number Recorded`, { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar(`Record ${titalise(phoneType)} Telephone Number Dial Failed`, { variant: 'error' });
    //         // this.setState({
    //         //     disableSalesStatusSubmitButton: false,
    //         // });
    //     });
    // };

    // handleInvalidAddressSwitchClick = async () => {
    //     this.setState((state) => ({
    //         disableInvalidAddressSwitch: true,
    //         invalidAddressData: {
    //             invalidAddressReason: '',
    //         },
    //     }));
    //     const newState = this.props.contact.invalidAddress !== true;
    //     if (newState === true) {
    //         this.setState(() => ({
    //             showInvalidAddressDialog: true,
    //         }));
    //         return;
    //     }
    //     this.invalidAddressToggle();
    // };

    // handleInvalidMobileTelephoneNumberSwitchClick = async () => {
    //     this.setState((state) => ({
    //         disableInvalidMobileTelephoneNumberSwitch: true,
    //         invalidMobileTelephoneNumberData: {
    //             invalidMobileTelephoneNumberReason: '',
    //         },
    //     }));
    //     const newState = this.props.contact.invalidMobileTelephoneNumber !== true;
    //     if (newState === true) {
    //         this.setState(() => ({
    //             showInvalidMobileTelephoneNumberDialog: true,
    //         }));
    //         return;
    //     }
    //     this.invalidMobileTelephoneNumberToggle();
    // };

    // invalidAddressToggle = () => {
    //     this.setState({
    //         disableInvalidAddressSubmitButton: true,
    //     });
    //     const newState = this.props.contact.invalidAddress !== true;
    //     const payload = {
    //         invalidAddress: newState,
    //         invalidAddressReason: this.state.invalidAddressData.invalidAddressReason,
    //     };
    //     this.props.updateContactDetails(payload).then(() => {
    //         this.setState({
    //             disableInvalidAddressSubmitButton: false,
    //             disableInvalidAddressSwitch: false,
    //             showInvalidAddressDialog: false,
    //         });
    //         this.props.enqueueSnackbar('Changed Valid Address Status', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Change Valid Address Status Failed', { variant: 'error' });
    //         this.setState({
    //             disableInvalidAddressSubmitButton: false,
    //             disableInvalidAddressSwitch: false,
    //         });
    //     });
    // };

    // invalidMobileTelephoneNumberToggle = () => {
    //     this.setState({
    //         disableInvalidMobileTelephoneNumberSubmitButton: true,
    //     });
    //     const newState = this.props.contact.invalidMobileTelephoneNumber !== true;
    //     const payload = {
    //         invalidMobileTelephoneNumber: newState,
    //         invalidMobileTelephoneNumberReason: this.state.invalidMobileTelephoneNumberData.invalidMobileTelephoneNumberReason,
    //     };
    //     this.props.updateContactDetails(payload).then(() => {
    //         this.setState({
    //             disableInvalidMobileTelephoneNumberSubmitButton: false,
    //             disableInvalidMobileTelephoneNumberSwitch: false,
    //             showInvalidMobileTelephoneNumberDialog: false,
    //         });
    //         this.props.enqueueSnackbar('Changed Valid Mobile Telephone Number Status', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Change Valid Mobile Telephone Number Status Failed', { variant: 'error' });
    //         this.setState({
    //             disableInvalidMobileTelephoneNumberSubmitButton: false,
    //             disableInvalidMobileTelephoneNumberSwitch: false,
    //         });
    //     });
    // };

    // handleForbidAgreementSwitchClick = async () => {
    //     if (!this.props.user.userScopes.includes('forbidAgreementToggle:*')) return;
    //     this.setState((state) => ({
    //         disableInvalidAddressSwitch: true,
    //         forbidAgreementData: {
    //             forbidAgreementReason: '',
    //         },
    //     }));
    //     // const newState = this.props.contact.forbidAgreement !== true;
    //     // if (newState === true) {
    //     this.setState(() => ({
    //         showForbidAgreementDialog: true,
    //     }));

    //     // }
    //     // this.forbidAgreementToggle();
    // };

    // forbidAgreementToggle = () => {
    //     this.setState({
    //         disableForbidAgreementSubmitButton: true,
    //     });
    //     const newState = this.props.contact.forbidAgreement !== true;
    //     const payload = {
    //         forbidAgreement: newState,
    //         forbidAgreementReason: this.state.forbidAgreementData.forbidAgreementReason,
    //     };
    //     this.props.updateContactDetails(payload).then(() => {
    //         this.setState({
    //             disableForbidAgreementSubmitButton: false,
    //             disableForbidAgreementSwitch: false,
    //             showForbidAgreementDialog: false,
    //         });
    //         this.props.enqueueSnackbar('Changed Allow Agreement Status', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Change Allow Agreement Status Failed', { variant: 'error' });
    //         this.setState({
    //             disableForbidAgreementSubmitButton: false,
    //             disableForbidAgreementSwitch: false,
    //         });
    //     });
    // };

    // handleForbidSaleSwitchClick = async () => {
    //     if (!this.props.user.userScopes.includes('forbidSaleToggle:*')) return;
    //     this.setState((state) => ({
    //         disableForbidSaleSwitch: true,
    //         forbidSaleData: {
    //             forbidSaleReason: '',
    //         },
    //     }));
    //     const newState = this.props.contact.forbidSale !== true;
    //     if (newState === true) {
    //         this.setState(() => ({
    //             showForbidSaleDialog: true,
    //         }));
    //         return;
    //     }
    //     this.forbidSaleToggle();
    // };

    // forbidSaleToggle = () => {
    //     this.setState({
    //         disableForbidSaleSubmitButton: true,
    //     });
    //     const newState = this.props.contact.forbidSale !== true;
    //     const payload = {
    //         forbidSale: newState,
    //         forbidSaleReason: this.state.forbidSaleData.forbidSaleReason,
    //     };
    //     this.props.updateContactDetails(payload).then(() => {
    //         this.setState({
    //             disableForbidSaleSubmitButton: false,
    //             disableForbidSaleSwitch: false,
    //             showForbidSaleDialog: false,
    //         });
    //         this.props.enqueueSnackbar('Changed Valid Address Status', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Change Valid Address Status Failed', { variant: 'error' });
    //         this.setState({
    //             disableForbidSaleSubmitButton: false,
    //             disableForbidSaleSwitch: false,
    //         });
    //     });
    // };

    render() {
        const {
            classes,
            errors,
            fetchItemData,
            fetchHistoriesData,
            item,
            itemLoading,
            itemHistoriesLoading,
        } = this.props;
        const {
        } = this.state;

        return (
            <>
                <Tile
                    tileTitle="Item Delivery Note"
                    refreshAction={fetchItemData}
                    refreshing={itemLoading}
                    style
                >
                    { !itemLoading
                        ? (
                            <>
                                <Grid container spacing={0}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12}>
                                            <HybridTextField
                                                label="Delivery Note Code"
                                                text={`DN${item.deliveryNote.code}`}
                                                link={`/deliveryNote/${item.deliveryNote.code}`}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={0}>
                                        <Grid item xs={3}>
                                            <HybridTextField
                                                label="Supplier"
                                                text={item.deliveryNote.supplier}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <HybridTextField
                                                label="Reference Number"
                                                text={item.deliveryNote.reference}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={0}>
                                        <Grid item xs={3}>
                                            <HybridTextField
                                                label="Delivery Date"
                                                text={item.deliveryNote.deliveryDate ? moment(item.deliveryNote.deliveryDate).format('DD/MM/YYYY') : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <HybridTextField
                                                label="Processed By"
                                                text={item.deliveryNote.processedBy}
                                                link={`/contact/${item.deliveryNote.processedByContactCode}`}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={0}>
                                        <Grid item xs={12}>
                                            <HybridTextField
                                                label="Delivery Note Item Quantity"
                                                text={item.deliveryNote.itemQuantity}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={0}>
                                        <Grid item xs={3}>
                                            <HybridTextField
                                                label="Created Time/Date"
                                                text={item.deliveryNote.createdDateTime ? moment(item.deliveryNote.createdDateTime).format('HH:mm DD/MM/YYYY') : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <HybridTextField
                                                label="Created By"
                                                text={item.deliveryNote.createdBy}
                                                link={`/contact/${item.deliveryNote.createdByContactCode}`}
                                            />
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </>
                        )
                        : (
                            <div className={classes.progressContainer}>
                                <CircularProgress className={classes.progress} variant="indeterminate" />
                            </div>
                        )}
                </Tile>
            </>
        );
    }
}

export default withSnackbar(withStyles(styles)(ItemDeliveryNote));
